// @generated by tools/docgen — do not edit.
// Source: docs/examples/simple_model.md

import React from 'react';
import { SimpleModelDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function SimpleModelPage() {
  return (
    <ExampleLayout title="Simple model" demo={<SimpleModelDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This example introduces rx.model: a channel field holding a Django model instance, serialized with a DRF serializer you already write. Assigning an instance to the field delivers its serialized data to the frontend, typed to match the serializer.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-simple-model-backend">
        <ExampleSectionHeading id="examples-simple-model-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="simple_model/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-simple-model-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-simple-model-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="simple_model/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default SimpleModelPage;
